<template>
  <div class="empty-view">
    <v-card class="empty-card">
      <v-card-title class="d-flex align-center">
        <v-icon color="primary" size="24" class="mr-2">mdi-shield-alert</v-icon>
        Zugriff eingeschränkt
      </v-card-title>

      <v-divider class="card-divider"></v-divider>

      <v-card-text class="pt-6">
        <div class="text-center">
          <v-icon size="80" color="grey" class="mb-5">mdi-lock-outline</v-icon>
          <h2 class="text-h5 mb-2">Keine Berechtigungen</h2>
          <p class="text-body-1 mb-2">
            Sie haben keine Berechtigung, um auf diese Inhalte zuzugreifen.
          </p>
          <p class="text-caption text-medium-emphasis mb-6">
            Bitte wenden Sie sich an einen Administrator, wenn Sie der Meinung
            sind, dass Sie Zugriff haben sollten.
          </p>

          <v-btn
            color="success"
            variant="outlined"
            prepend-icon="mdi-arrow-left"
            class="home-btn"
            to="/"
          >
            Zurück zur Startseite
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup>
// Keine spezielle Logik erforderlich
</script>

<style scoped>
.empty-view {
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 24px;
  padding-bottom: 32px;
}

.empty-card {
  background-color: rgba(30, 30, 35, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.card-divider {
  opacity: 0.1;
}

.home-btn {
  letter-spacing: 0.5px;
  text-transform: none;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3) !important;
  border-radius: 8px;
  transition: all 0.3s ease;
  min-width: 200px;
  font-weight: 500;
  height: 42px;
}

.home-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(76, 175, 80, 0.4) !important;
}

@media (max-width: 600px) {
  .empty-view {
    padding: 16px;
  }

  .text-h5 {
    font-size: 1.25rem !important;
  }

  .text-body-1 {
    font-size: 0.9rem !important;
  }
}
</style>
